import * as actionTypes from "./ActionTypes";

export const setChatbotExternalData = (externalData) => {
  const requiredKeys = ["type", "content", "source"];
  const missing = requiredKeys.filter(k => !(k in externalData));

  if (missing.length > 0) {
    throw new Error(`Missing required keys: ${missing.join(", ")}`);
  }

  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_CHATBOT_EXTERNAL_DATA,
      payload: externalData,
    });
  };
};
